export default "__VITE_ASSET__BAfnTjtS__"